/******************************************************************************
 * This file was generated by langium-cli 3.3.0.
 * DO NOT EDIT MANUALLY!
 ******************************************************************************/

import type { LangiumSharedCoreServices, LangiumCoreServices, LangiumGeneratedCoreServices, LangiumGeneratedSharedCoreServices, LanguageMetaData, Module } from 'langium';
import { IprotoAstReflection } from './ast.js';
import { IprotoGrammar } from './grammar.js';

export const IprotoLanguageMetaData = {
    languageId: 'iproto',
    fileExtensions: ['.iproto'],
    caseInsensitive: false,
    mode: 'production'
} as const satisfies LanguageMetaData;

export const IprotoGeneratedSharedModule: Module<LangiumSharedCoreServices, LangiumGeneratedSharedCoreServices> = {
    AstReflection: () => new IprotoAstReflection()
};

export const IprotoGeneratedModule: Module<LangiumCoreServices, LangiumGeneratedCoreServices> = {
    Grammar: () => IprotoGrammar(),
    LanguageMetaData: () => IprotoLanguageMetaData,
    parser: {}
};
